import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1120c772"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between border-bottom border-2 pb-4 mb-4" }
const _hoisted_2 = { class: "fs-5 d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "me-4",
  src: "/media/payment-methods/creditcard.svg",
  style: {"width":"24px","filter":"invert(28%) sepia(67%) saturate(2000%) hue-rotate(242deg) brightness(79%) contrast(95%)"}
}, null, -1))
const _hoisted_4 = { class: "d-flex flex-column mb-7 fv-row fv-plugins-icon-container" }
const _hoisted_5 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_6 = { class: "required" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex flex-column mb-7 fv-row fv-plugins-icon-container"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "CPF")
], -1))
const _hoisted_9 = { class: "fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" }
const _hoisted_10 = {
  key: 1,
  class: "d-flex flex-column mb-7 fv-row fv-plugins-icon-container"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "CNPJ")
], -1))
const _hoisted_12 = { class: "fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" }
const _hoisted_13 = { class: "d-flex flex-column mb-7 fv-row fv-plugins-icon-container" }
const _hoisted_14 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_15 = { class: "required" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ms-1",
  "data-bs-toggle": "tooltip",
  "aria-label": "Specify a card holder's name",
  "data-bs-original-title": "Specify a card holder's name",
  "data-kt-initialized": "1"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ki-duotone ki-information-5 text-gray-500 fs-6" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
    /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
    /*#__PURE__*/_createElementVNode("span", { class: "path3" })
  ])
], -1))
const _hoisted_17 = { class: "fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" }
const _hoisted_18 = { class: "d-flex flex-column mb-7 fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid" }
const _hoisted_19 = { class: "required fs-6 fw-semibold form-label mb-2" }
const _hoisted_20 = { class: "position-relative" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle-y top-50 end-0 me-5 d-none d-lg-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/svg/card-logos/visa.svg",
    alt: "",
    class: "me-3 h-25px"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/svg/card-logos/mastercard.svg",
    alt: "",
    class: "me-3 h-25px"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "/media/svg/card-logos/american-express.svg",
    alt: "",
    class: "me-3 h-25px"
  })
], -1))
const _hoisted_22 = { class: "fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" }
const _hoisted_23 = { class: "row mb-10" }
const _hoisted_24 = { class: "col-12 col-lg-6 fv-row mb-10 mb-lg-0" }
const _hoisted_25 = { class: "required fs-6 fw-semibold form-label mb-2" }
const _hoisted_26 = { class: "fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" }
const _hoisted_27 = { class: "col-12 col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "CVV")
], -1))
const _hoisted_29 = { class: "position-relative" }
const _hoisted_30 = { class: "fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" }
const _hoisted_31 = { class: "row mb-10" }
const _hoisted_32 = { class: "fs-6 fw-semibold form-label mb-2" }
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" }
const _hoisted_37 = { class: "fs-4 my-7" }
const _hoisted_38 = { class: "row mb-7" }
const _hoisted_39 = { class: "col-12 col-lg-6" }
const _hoisted_40 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_41 = { class: "required" }
const _hoisted_42 = { class: "fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" }
const _hoisted_43 = { class: "row mb-7" }
const _hoisted_44 = { class: "col-12" }
const _hoisted_45 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_46 = { class: "required" }
const _hoisted_47 = { class: "row mb-7" }
const _hoisted_48 = { class: "col-12 col-lg-6" }
const _hoisted_49 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_50 = { class: "required" }
const _hoisted_51 = { class: "fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback" }
const _hoisted_52 = { class: "col-12 col-lg-6" }
const _hoisted_53 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_54 = { class: "" }
const _hoisted_55 = { class: "row mb-7" }
const _hoisted_56 = { class: "col-12" }
const _hoisted_57 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_58 = { class: "" }
const _hoisted_59 = { class: "row mb-7" }
const _hoisted_60 = { class: "col-12 col-lg-9" }
const _hoisted_61 = { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }
const _hoisted_62 = { class: "" }
const _hoisted_63 = { class: "col-12 col-lg-3" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-semibold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "UF")
], -1))
const _hoisted_65 = { class: "text-center pt-5" }
const _hoisted_66 = ["disabled"]
const _hoisted_67 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right-square-fill" }, null, -1))
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

import {Actions} from "@/store/enums/StoreEnums";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";
import IuguService from '@/core/services/IuguService'
import ApiService from "@/core/services/ApiService";
import {AxiosRequestConfig} from "axios";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import {useI18n} from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  emits: ['goBack', 'finish'],
  setup(__props, { emit }) {

const iugu = window.Iugu

const store = useStore();
const saving = ref(false)
const { t } = useI18n();
const cpfOrCnpj = ref(true);

const installmentsData = computed(() => store.getters.getInstallmentData)
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));

const data = ref({
  form:{
    document: '',
    name:'',
    number:'',
    verification_value:'',
    expiration_date:'',
    installment: 12,
    phone: '',
    zip_code: '',
    street: '',
    street_number: '',
    district: '',
    city: '',
    state: '',
    complement:''
  },
  errors:{},
  cardBrand: ''
})
// let installments:Array<object> = []
// for(let i=1;i<=12;i++){
//   const value = new Intl.NumberFormat('pt-BR', {style:'currency', currency:'BRL'}).format(((store.getters.getPlan.value_cents/100)/i))
//   installments.push({
//     value: i,
//     label: `${i}x of ${value}`
//   })
// }

const calculateInstallments = (installmentsData) => {
  let installmentsList = [];
  for(let i=1; i<=12; i++) {
    if (installmentsData.installments && installmentsData.installments.hasOwnProperty(i.toString())) {
      let installmentValue = parseInt(installmentsData.installments[i], 10) / 100;
     

      const value = new Intl.NumberFormat('pt-BR', {
        style:'currency',
        currency:'BRL'
      }).format(installmentValue);


      installmentsList.push({
        value: i,
        label: `${i}x de ${value}`
      });
    }
  }
  return installmentsList;
}

const installments = computed(() => calculateInstallments(installmentsData.value));

onMounted(async () => {
  await store.dispatch(Actions.GET_INSTALLMENTS, 2)
})

Yup.addMethod(Yup.number, "creditCardValid", function(errorMessage){
  return this.test('validate-card-number', errorMessage, function(value){
    const { path, createError } = this
    if(String(value).length < 16)
      return true

    if(!iugu.utils.validateCreditCardNumber(String(value)))
      return createError({path, message: errorMessage})

    return true
  })
})

Yup.addMethod(Yup.string, "validCPF", function(errorMessage){
  return this.test("validate-cpf", errorMessage, function(cpfString=''){
    let validated = false; // Start with false
    // Checking cpf lenght
    if (cpfString.length < 14) {
      return true;
    }

    if (cpfString.length === 14) {
      cpfString = cpfString.replace('.', '');
      cpfString = cpfString.replace('.', '');
      cpfString = cpfString.replace('-', '');
    }

    // Variables to check cpf valid (sum and rest)
    let sum = 0, rest = 0;

    // Checking for "null" CPF
    if (cpfString === '00000000000') {
      return validated;
    }

    // sum numbers
    for (let i = 1; i <= 9; ++i) {
      sum += (parseInt(cpfString.substring(i - 1, i)) * (11 - i));
    }

    // Getting rest
    rest = (sum * 10) % 11;

    if ((rest == 10) || (rest == 11)) {
      rest = 0;
    }

    if (rest != parseInt(cpfString.substring(9, 10))) {
      return validated;
    }

    validated = true;
    return validated;
  })
})

Yup.addMethod(Yup.string, "validCNPJ", function(errorMessage){
  return this.test("validate-cnpj", errorMessage, function(cnpjString=''){
    cnpjString = cnpjString.replace(/\D/g, '');
    let validated = false;
    if (cnpjString.length !== 14) {
      return false;
    }

    if (cnpjString.length === 14) {
      cnpjString = cnpjString.replace('.', '');
      cnpjString = cnpjString.replace('/', '');
      cnpjString = cnpjString.replace('.', '');
      cnpjString = cnpjString.replace('-', '');
    }

    let size = cnpjString.length - 2;
    let numbers = cnpjString.substring(0, size);
    let digits = cnpjString.substring(size);
    let sum = 0, pos = size - 7;

    if (cnpjString === '00000000000000') {
      return validated;
    }

    for (let i = size; i >= 1; i--) {
      sum += numbers.charAt(size - i) * pos--;
      if (pos < 2) pos = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result != digits.charAt(0)) {
      return validated;
    }

    size = size + 1;
    numbers = cnpjString.substring(0, size);
    sum = 0;
    pos = size - 7;

    for (let i = size; i >= 1; i--) {
      sum += numbers.charAt(size - i) * pos--;
      if (pos < 2) pos = 9;
    }

    result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result != digits.charAt(1)) {
      return validated;
    }

    validated = true;
    return validated;
  })
})
//66428527000120

const validationSchema = Yup.object().shape({
  document: cpfOrCnpj.value ? Yup.string().required(t(`${currentLanguage.value}.messages.document_is_a_required_field`))
      .test('cpf-or-cnpj', t(`${currentLanguage.value}.messages.invalid_document_number`), function(value) {
        const { path, createError } = this;
        if (cpfOrCnpj.value) {
          return Yup.string().validCPF().isValidSync(value) || createError({ path, message: t(`${currentLanguage.value}.messages.invalid_document_number`) });
        } else {
          return Yup.string().validCNPJ().isValidSync(value) || createError({ path, message: t(`${currentLanguage.value}.messages.invalid_document_number`) });
        }
      }) : Yup.string().required(t(`${currentLanguage.value}.messages.document_is_a_required_field`)),
  name: Yup.string().required(t(`${currentLanguage.value}.profile.name_is_a_required_field`)),
  number: Yup.number().typeError(t(`${currentLanguage.value}.messages.card_number_must_be_a_number`)).required(t(`${currentLanguage.value}.messages.card_number_is_a_required_field`)).creditCardValid(t(`${currentLanguage.value}.messages.card_number_is_invalid`)),
  verification_value: Yup.number().typeError(t(`${currentLanguage.value}.messages.cvv_must_be_a_number`)).required(),
  expiration_date: Yup.string().required(t(`${currentLanguage.value}.messages.expiration_date_is_a_required_field`)),
  zip_code: Yup.string().required(t(`${currentLanguage.value}.messages.zip_code_is_a_required_field`)),
  street_number: Yup.string().required(t(`${currentLanguage.value}.messages.number_is_a_required_field`)),
  street: Yup.string().required(t(`${currentLanguage.value}.messages.street_is_a_required_field`)),
  city: Yup.string().required(t(`${currentLanguage.value}.messages.city_is_a_required_field`)),
  state: Yup.string().required(t(`${currentLanguage.value}.messages.state_is_a_required_field`)),
});

const submit = async () => {
  const result_validation = await validationSchema.validate(data.value.form).then(() => {
    
    return true;
  }).catch((err) => {
    console.log("Error");
    console.log(err)
    new Error(err);
    return false;
  });

  if(!result_validation){
    return;
  }
  
  saving.value = true
  try{
    const iuguToken:any = await getIuguToken();
    const document = cpfOrCnpj.value ?
        data.value.form.document.replaceAll("-","").replaceAll(".", "") :
        data.value.form.document.replaceAll(".", "").replaceAll("/","").replaceAll("-","")

    await insertPayer()

    const charge_request = {
      "plan_id": store.getters.getPlan.id,
      "method": "",
      "months": data.value.form.installment > 1 ? data.value.form.installment : 1,
      "cpf": document,
      "card":{
        "token": iuguToken.id,
        "description": t(`${currentLanguage.value}.messages.checkout_credit_card`),
        "set_as_default": true
      }
    }

    try{
      await ApiService.post('charge/store', charge_request as AxiosRequestConfig)
    }catch(e){
      saving.value = false
      if(e.response.status == 402 && e.response.data?.message == "Cobrança criada com sucesso, transação negada"){
        Swal.fire({
          title: "Oops...",
          text: 'Transação negada, verifique os dados do cartão e tente novamente.',
          icon: "error",
          confirmButtonText: "Ok",
        });
        return
      }else{

        Swal.fire({
          title: "Oops...",
          text: 'Ocorreu um erro ao processar o pagamento, por favor, tente novamente.',
          icon: "error",
          confirmButtonText: "Ok",
        });
      }

      return
    }


    emit('finish')
  }catch(e){
    console.error(e)
    Swal.fire({
        title: "Oops...",
        text: 'Ocorreu um erro ao processar o pagamento, por favor, tente novamente.',
        icon: "error",
        confirmButtonText: "Refresh",
      }).then(() => {
        window.location.reload()
      });
    
  }
  saving.value = false
}
const insertPayer = () =>{
  return new Promise(async (resolve, reject)=>{
    try{
      const phone = data.value.form.phone
          .replaceAll("(", "")
          .replaceAll(")", "")
          .replaceAll(" ", "")
          .replaceAll("-", "")
          .replaceAll("+", "");

      
      let json_data = {
        ... data.value.form,
        number: data.value.form.street_number,
        cpf_cnpj : data.value.form.document.replaceAll("-","").replaceAll(".", ""),
        phone_prefix: phone.substr(0, 2),
        phone: phone.substr(2,phone.length-2),
        verification_value: null
      }
      // remove verification_value from json_data
      
      const payerResponse = await ApiService.post('payer/store', json_data as AxiosRequestConfig)

      resolve(payerResponse.data)
    }catch(e){
      reject(e)
    }
  })
}
const getIuguToken = () => {
  return new Promise(async (resolve, reject) => {
    const credit_card = {
      number: data.value.form.number.replaceAll(" ", ""),
      verification_value: data.value.form.verification_value,
      first_name:data.value.form.name.split(' ')[0],
      last_name:data.value.form.name.split(' ').slice(1).join(" "),
      month:data.value.form.expiration_date.substr(0, 2),
      year:data.value.form.expiration_date.substr(3, 4)
    }

    try{
      const token = await IuguService.getIuguCardToken(credit_card);
      resolve(token)
    }catch(e){
      console.error(e)
      reject(e)
    }
  })
}
const getZipCodeInfo = async () => {
  const zipcode = data.value.form.zip_code.replaceAll('-', '')

  if(zipcode.length >= 8){
    try{
      const zipcode_response = await fetch(`https://viacep.com.br/ws/${zipcode}/json/`)
      const address_json = await zipcode_response.json()

      data.value.form.street = address_json.logradouro
      data.value.form.district = address_json.bairro
      data.value.form.city = address_json.localidade
      data.value.form.state = address_json.uf
    }catch(e){
      console.error(e)
    }
  }
}

const toggleCpfOrCnpj = ()=>{
  cpfOrCnpj.value = !cpfOrCnpj.value
  // if(data.value.form.document.length == 14){
  //   data.value.form.document = data.value.form.document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  // }else{
  //   data.value.form.document = data.value.form.document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  // }
}


return (_ctx: any,_cache: any) => {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.common.credit_card`)), 1)
      ]),
      _createElementVNode("div", {
        class: "cursor-pointer text-purple text-hover-secondary fs-5",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('goBack')))
      }, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.common.back`)), 1)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_unref(Form), {
        id: "kt_modal_new_card_form",
        class: "form fv-plugins-bootstrap5 fv-plugins-framework",
        "validation-schema": _unref(validationSchema)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createTextVNode(_toDisplayString(_unref(t)(`${_unref(currentLanguage)}.profile.billing.buy_with`)) + " ", 1),
                _createElementVNode("span", {
                  class: "ms-1 cursor-pointer text-success text-hover-success fs-6 bg-light rounded px-2 py-1",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleCpfOrCnpj()))
                }, _toDisplayString(cpfOrCnpj.value ? 'CNPJ' : 'CPF'), 1)
              ])
            ])
          ]),
          (cpfOrCnpj.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createVNode(_unref(Field), {
                  type: "text",
                  class: "form-control form-control-solid",
                  placeholder: "",
                  modelValue: data.value.form.document,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.form.document) = $event)),
                  name: "document"
                }, null, 8, ["modelValue"]), [
                  [_directive_maska, '###.###.###-##']
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(ErrorMessage), { name: "document" })
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createVNode(_unref(Field), {
                  type: "text",
                  class: "form-control form-control-solid",
                  placeholder: "",
                  modelValue: data.value.form.document,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.form.document) = $event)),
                  name: "document"
                }, null, 8, ["modelValue"]), [
                  [_directive_maska, '##.###.###/####-##']
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_unref(ErrorMessage), { name: "document" })
                ])
              ])),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.common.name_on_card`)), 1),
              _hoisted_16
            ]),
            _createVNode(_unref(Field), {
              type: "text",
              class: "form-control form-control-solid",
              placeholder: "",
              modelValue: data.value.form.name,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.form.name) = $event)),
              name: "name"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_unref(ErrorMessage), { name: "name" })
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.profile.billing.card_number`)), 1),
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createVNode(_unref(Field), {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "Enter card number",
                modelValue: data.value.form.number,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.value.form.number) = $event)),
                name: "number"
              }, null, 8, ["modelValue"]), [
                [_directive_maska, '#### #### #### ####']
              ]),
              _hoisted_21
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_unref(ErrorMessage), { name: "number" })
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.profile.billing.expiration_date`)), 1),
              _withDirectives(_createVNode(_unref(Field), {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "MM/YYYY",
                modelValue: data.value.form.expiration_date,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((data.value.form.expiration_date) = $event)),
                name: "expiration_date"
              }, null, 8, ["modelValue"]), [
                [_directive_maska, '##/####']
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_unref(ErrorMessage), { name: "expiration_date" })
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _withDirectives(_createVNode(_unref(Field), {
                  type: "text",
                  class: "form-control form-control-solid",
                  maxlength: "4",
                  placeholder: "CVV",
                  name: "verification_value",
                  modelValue: data.value.form.verification_value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((data.value.form.verification_value) = $event))
                }, null, 8, ["modelValue"]), [
                  [_directive_maska, '####']
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_unref(ErrorMessage), { name: "verification_value" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("label", _hoisted_32, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.profile.billing.installment`)), 1),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_unref(Field), {
                as: "select",
                name: "installment",
                class: "form-select form-select-solid select2-hidden-accessible",
                modelValue: data.value.form.installment,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((data.value.form.installment) = $event))
              }, {
                default: _withCtx(() => [
                  (_unref(installments).length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(installments), (installment) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: `installment-${installment.value}`,
                          value: installment.value
                        }, _toDisplayString(installment.label), 9, _hoisted_34))
                      }), 128))
                    : (_openBlock(), _createElementBlock("option", _hoisted_35, _toDisplayString(_unref(t)(`${_unref(currentLanguage)}.common.loading`)) + "...", 1))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_unref(ErrorMessage), { name: "installment" })
              ])
            ])
          ]),
          _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.address`)), 1),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("label", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.zip_code`)), 1)
              ]),
              _withDirectives(_createVNode(_unref(Field), {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "",
                modelValue: data.value.form.zip_code,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((data.value.form.zip_code) = $event)),
                name: "zip_code",
                onInput: getZipCodeInfo
              }, null, 8, ["modelValue"]), [
                [_directive_maska, '#####-###']
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_unref(ErrorMessage), { name: "zip_code" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("label", _hoisted_45, [
                _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.street`)), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "Preenchiemento automático",
                name: "street",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((data.value.form.street) = $event))
              }, null, 512), [
                [_vModelText, data.value.form.street]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("label", _hoisted_49, [
                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.number`)), 1)
              ]),
              _createVNode(_unref(Field), {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "",
                modelValue: data.value.form.street_number,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((data.value.form.street_number) = $event)),
                name: "street_number"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_unref(ErrorMessage), { name: "street_number" })
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("label", _hoisted_53, [
                _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.complement`)), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "Ex: apto 123",
                name: "complement",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((data.value.form.complement) = $event))
              }, null, 512), [
                [_vModelText, data.value.form.complement]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("label", _hoisted_57, [
                _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.district`)), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "Preenchiemento automático",
                name: "district",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((data.value.form.district) = $event))
              }, null, 512), [
                [_vModelText, data.value.form.district]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("label", _hoisted_61, [
                _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.city`)), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "Preenchiemento automático",
                name: "city",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((data.value.form.city) = $event))
              }, null, 512), [
                [_vModelText, data.value.form.city]
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _hoisted_64,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-solid",
                placeholder: "Ex: SP",
                name: "state",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((data.value.form.state) = $event))
              }, null, 512), [
                [_vModelText, data.value.form.state]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("button", {
              id: "kt_modal_new_card_submit",
              class: "btn btn-success",
              type: "button",
              onClick: submit,
              disabled: saving.value
            }, [
              (!saving.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_67, [
                    _createTextVNode(_toDisplayString(_unref(t)(`${_unref(currentLanguage)}.common.button_member`)) + "   ", 1),
                    _hoisted_68
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_69, [
                    _createTextVNode(_toDisplayString(_unref(t)(`${_unref(currentLanguage)}.profile.please_wait`)) + "... ", 1),
                    _hoisted_70
                  ]))
            ], 8, _hoisted_66)
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ], 64))
}
}

})